// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ForSalePropertyTypeDisplayName_property_graphql = require("../../../__generated__/ForSalePropertyTypeDisplayName_property_graphql.bs.js");

let convertFragment = ForSalePropertyTypeDisplayName_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertyTypeDisplayName_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertyTypeDisplayName_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertyTypeDisplayName_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertyTypeDisplayName_property_graphql.node, convertFragment, fRef);
}

let Fragment_forSalePropertyMatchingType_decode = ForSalePropertyTypeDisplayName_property_graphql.Utils.forSalePropertyMatchingType_decode;

let Fragment_forSalePropertyMatchingType_fromString = ForSalePropertyTypeDisplayName_property_graphql.Utils.forSalePropertyMatchingType_fromString;

let Fragment = {
  forSalePropertyMatchingType_decode: Fragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: Fragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ForSalePropertyTypeDisplayName(props) {
  let property = RescriptRelay_Fragment.useFragment(ForSalePropertyTypeDisplayName_property_graphql.node, convertFragment, props.property);
  let match = property.forSalePropertyMatchingType;
  let tmp;
  if (match === "BROADCAST" || match === "QUIET_ANONYMOUS" || match === "ONE_WAY" || match === "QUIET") {
    switch (match) {
      case "BROADCAST" :
        let match$1 = property.anonymousProperty;
        tmp = match$1 !== undefined && match$1 ? "Anonymous broadcast property" : "Broadcast property";
        break;
      case "ONE_WAY" :
        tmp = "Hidden property";
        break;
      case "QUIET" :
        tmp = "Quiet property";
        break;
      case "QUIET_ANONYMOUS" :
        tmp = "Anonymous quiet property";
        break;
    }
  } else {
    tmp = "Broadcast property";
  }
  return props.render(tmp);
}

let make = ForSalePropertyTypeDisplayName;

exports.Fragment = Fragment;
exports.make = make;
/* RescriptRelay_Fragment Not a pure module */
